import { TextField } from "@mui/material";
import { memo, useCallback, type ChangeEvent } from "react";
import { type FieldCopy } from "../tenedi-connection-copy";

type IdentityTextFieldProps<Name extends string> = {
  readonly name: Name;
  readonly copy: FieldCopy;
  readonly value: string;
  readonly error: string | undefined;
  readonly disabled: boolean;
  readonly onChange: (name: Name, value: string) => void;
};

/** One id box: the plain-language label, its helper text, and the field's validation message in place of the helper. */
const IdentityTextFieldInner = <Name extends string>({
  name,
  copy,
  value,
  error,
  disabled,
  onChange,
}: IdentityTextFieldProps<Name>) => {
  const handleChange = useCallback(
    (event: ChangeEvent<HTMLInputElement | HTMLTextAreaElement>) => {
      onChange(name, event.target.value);
    },
    [name, onChange],
  );

  return (
    <TextField
      fullWidth
      disabled={disabled}
      error={error !== undefined}
      helperText={error ?? copy.helper}
      label={copy.label}
      size="small"
      value={value}
      onChange={handleChange}
    />
  );
};

const IdentityTextField = memo(
  IdentityTextFieldInner,
) as typeof IdentityTextFieldInner & { displayName?: string };
IdentityTextField.displayName = "IdentityTextField";

export default IdentityTextField;
